import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function AgencyOperationsAdminVenueBookingTabs({
    overlay = false
}: React.PropsWithChildren<{
    overlay?: boolean
}>): React.ReactElement {

    const { currentItemId } = useAppState(state=>state.bookings)
    const { currentItemId: currentTenatId } = useAppState(state=>state.tenants)

    return ( 
        <NavTabs
            overlay={overlay}
            parentId={currentItemId}
            urlRoot={`/venues/${currentTenatId}/bookings`}
            tabs={{
                details: {
                    label: 'Venue Booking Overview',
                    icon: 'home',
                    route: ''
                },
                guidelines: {
                    label: 'Venue Booking Guidelines',
                    icon: 'guideline',
                    route: 'guidelines'
                }
            }}
        />
    )

}